import type { EcommerceItem } from '@/types/shared/player-config'
import type { CARD_COLORS } from '@/enums/common'

export type EcommercePrizeCardItem = EcommerceItem & { color: CARD_COLORS, timeImage: string, disabledSeconds: number }

export enum DISCOUNT_EVENT {
  DEFAULT = 'default',
  IWD = 'IWD',
  STP = 'STP', // Saint Patrick's Day
}